import { createSlice } from "@reduxjs/toolkit";

export type StepsToRecordVideoState = {
  page: number;
  recordingStarted: boolean;
};

const initialState: StepsToRecordVideoState = {
  page: 1,
  recordingStarted: false
};

/** Steps to record video Slice */
const { reducer, actions } = createSlice({
  name: "stepsToRecordVideo",
  initialState,
  reducers: {
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    startRecording: (state, { payload }) => {
      state.recordingStarted = payload;
    }
  }
});

export const { setPage, startRecording } = actions;

export default reducer;
